import { Pipe, PipeTransform } from '@angular/core';

const TIME_STRING_PATTERN = /^\d{1,2}:\d{2}/;

@Pipe({
  name: '_clock',
  pure: true,
  standalone: true,
})
export class ClockPipe implements PipeTransform {
  private static readonly intlFormatter = new Intl.DateTimeFormat('pt-BR', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });

  public transform(value: string | Date | null | undefined): string {
    if (value == null || value === '') {
      return '';
    }

    if (value instanceof Date) {
      return ClockPipe.intlFormatter.format(value);
    }

    const str = String(value).trim();
    if (!str) {
      return '';
    }

    if (TIME_STRING_PATTERN.test(str)) {
      const match = str.match(/^(\d{1,2}):(\d{2})/);
      if (match) {
        return `${match[1].padStart(2, '0')}:${match[2]}`;
      }
    }

    const date = new Date(str);
    if (!Number.isNaN(date.getTime())) {
      return ClockPipe.intlFormatter.format(date);
    }

    return '';
  }
}
